$(document).ready(function() {
	var arrivalDate = $("input[name=arrivalTimeOfLastLeg]").val();
	var airportCode = $("input[name=arrivalAirportCode]").val();

	getSuggestedTransfers(arrivalDate, airportCode);
});


function getSuggestedTransfers(arrivalDate, airportCode){
	$.ajax({
		url : "/suggestedTransfers",
		dataType : "html",
		data :{
			arrivalTimeOfLastLeg : arrivalDate,
			airportCode: airportCode
		},
		success : function(data) {
			if(data){
				$("#suggestedTransferDiv").html(data);
			} else {
				$("#suggestedTransferDiv").html('');
			}
		},
		error : function(err){
			$("#suggestedTransferDiv").html('');
		}
	});
}